/**
 * Codes for section call-to-action widgets displayed in the Visitors Area.
 */
export enum SectionCTAEnum {
  parking = 'parking',
  breakfast = 'breakfast',
  additionalCleaning = 'additional-cleaning',
  extendStay = 'extend-stay',
  earlyCheckIn = 'early-check-in',
  lateCheckOut = 'late-check-out',
  customRequest = 'custom-request',
}
